/**
 * Latest Report Title Async Loader
 * Handles asynchronous loading of the latest report title via AJAX
 */
export function initLatestReportTitle() {
    const elements = document.querySelectorAll('[data-latest-report-title]');
    if (!elements.length) return;

    elements.forEach(element => {
        loadLatestReportTitle(element);
    });
}

/**
 * Load latest report title for a specific element
 * @param {HTMLElement} element - The element to update with the report title
 */
async function loadLatestReportTitle(element) {
    // Get language from data attribute
    const lang = element.dataset.lang || 'sv';

    try {
        // Build API URL
        const apiUrl = new URL('/api/reports/latest', window.location.origin);
        apiUrl.searchParams.append('lang', lang);

        const response = await fetch(apiUrl.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to load latest report title');
        }

        const data = await response.json();

        // Update the element with the report title with smooth animation
        if (data.title && element.textContent !== data.title) {
            // Fade out and slide up
            element.style.opacity = '0';
            element.style.transform = 'translateY(-10px)';
            element.style.transition = 'opacity 300ms ease-in-out, transform 300ms ease-in-out';
            
            // Wait for fade out to complete, then update text and fade in from below
            setTimeout(() => {
                element.textContent = data.title;
                element.style.transform = 'translateY(10px)';
                element.style.opacity = '0';
                
                // Trigger reflow to ensure the transform is applied before animating back
                element.offsetHeight;
                
                element.style.transform = 'translateY(0)';
                element.style.opacity = '1';
            }, 300);
        }
    } catch (error) {
        console.error('Error loading latest report title:', error);
        // Keep the default text on error
    }
}
